import request from '@/http/request'
import wayCode from "@/utils/wayCode";
import channelUserIdUtil from "@/utils/channelUserId";
import config from '@/config'

function getDefaultWayCode () {
  const currentPayWay = wayCode.getPayWay()
  return currentPayWay ? currentPayWay.wayCode : ''
}

/** 获取url **/
export function getRedirectUrl (payWayCode) {
  return request.request({
    url: '/api/cashier/redirectUrl',
    method: 'POST',
    data: { wayCode: payWayCode || wayCode.getPayWay().wayCode, token: config.cacheToken }
  })
}

/** 获取url **/
export function getChannelUserId (redirectData, payWayCode) {
  return request.request({
    url: '/api/cashier/channelUserId',
    method: 'POST',
    data: Object.assign({ wayCode: payWayCode || wayCode.getPayWay().wayCode, token: config.cacheToken }, redirectData)
  })
}

/** 调起支付接口, 获取支付数据包 **/
export function getPayPackage (amount, payWayCode, extraData) {
  return request.request({
    url: '/api/cashier/pay',
    method: 'POST',
    data: Object.assign({
      wayCode: payWayCode || wayCode.getPayWay().wayCode,
      token: config.cacheToken,
      amount: amount,
      channelUserId: channelUserIdUtil.getChannelUserId(),
      productId: null
    }, extraData || {})
  })
}

/** 商品码调起支付接口, 获取支付数据包 **/
export function getProductPayPackage (amount, productId, payWayCode, extraData) {
  return request.request({
    url: '/api/cashier/pay',
    method: 'POST',
    data: Object.assign({
      wayCode: payWayCode || wayCode.getPayWay().wayCode,
      token: config.cacheToken,
      amount: amount,
      productId: productId,
      channelUserId: channelUserIdUtil.getChannelUserId()
    }, extraData || {})
  })
}

/** 调起支付接口, 获取订单信息 **/
export function getPayOrderInfo (payWayCode, useDefaultWayCode = true) {
  return request.request({
    url: '/api/cashier/payOrderInfo',
    method: 'POST',
    data: {
      token: config.cacheToken,
      wayCode: payWayCode || (useDefaultWayCode ? getDefaultWayCode() : '')
    }
  })
}

/** 商品码匹配商品 **/
export function getProductMatch (amount) {
  return request.request({
    url: '/api/cashier/productMatch',
    method: 'POST',
    data: {
      token: config.cacheToken,
      amount: amount
    }
  })
}

/** 取消订单 **/
export function cancelPay () {
  return request.request({
    url: '/api/cashier/cancelPay',
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}
